import React, { useState } from "react"
import { jsonClone } from "../../../../../utils/json"
import { expandTreeOptions } from "../../../converters/filters"
import CheckboxFilterItemRecursive from "../CheckboxFilterItemRecursive"
import {
  CheckboxFilterOption,
  FilterCategory,
  FilterCategoryOptions,
} from "../types"

interface Props {
  item: FilterCategory
  onItemUpdate: (item: FilterCategory) => void
  className?: string
  maxScrollItems?: number
  defaultExpandedOptions?: CheckboxFilterOption[]
}

const castOptions = (options?: FilterCategoryOptions): CheckboxFilterOption[] =>
  (options as CheckboxFilterOption[]) ?? []

const getRootOptions = (
  options: CheckboxFilterOption[]
): CheckboxFilterOption[] => {
  return options.length === 1
    ? getRootOptions(options[0].children ?? [])
    : options
}

const toggleChildrenOptions = (
  options: CheckboxFilterOption[],
  selected: boolean,
  expandedMap: { [key: string]: boolean }
) => {
  options.forEach((x) => {
    x.selected = selected
    if (x.children) {
      // if (selected) {
      expandedMap = { ...expandedMap, [x.value]: selected }
      // }
      expandedMap = toggleChildrenOptions(x.children, selected, expandedMap)
    }
  })
  return expandedMap
}

// const toggleParentOptions = (option: CheckboxFilterOption) => {
//   if (!option.parent?.children) {
//     return
//   }
//   const parentChildren = option.parent.children
//   const allChildrenSelected =
//     parentChildren.filter((x) => !x.selected).length === 0
//   option.parent.selected = allChildrenSelected
//   toggleParentOptions(option.parent)
// }

type ExpansionMap = { [key: string]: boolean }

const createDefaultExpendedMap = (
  defaultExpandedOptions: CheckboxFilterOption[]
): ExpansionMap => {
  const map: ExpansionMap = {}
  defaultExpandedOptions.forEach((x) => (map[x.value] = true))
  return map
}

const CheckboxTreeFilter = ({
  item,
  onItemUpdate,
  className,
  maxScrollItems,
  defaultExpandedOptions,
}: Props) => {
  const [expandedMap, setExpandedMap] = useState<ExpansionMap>(
    defaultExpandedOptions
      ? createDefaultExpendedMap(defaultExpandedOptions)
      : {}
  )
  const options = getRootOptions(castOptions(item?.options))

  const toggleOption = (option: CheckboxFilterOption) => {
    if (option.customAction) {
      option.customAction()
      return
    }

    const updatedCategory = jsonClone(item) as FilterCategory
    const options = expandTreeOptions(castOptions(updatedCategory.options))
    const clickedOption = options.find((x) => x.value === option.value)
    if (!clickedOption) {
      throw new Error("Clicked option not found")
    }

    const newSelected = !clickedOption.selected
    clickedOption.selected = newSelected
    const children = expandTreeOptions(clickedOption.children ?? [])
    let newExpandedMap = JSON.parse(JSON.stringify(expandedMap)) as {
      [key: string]: boolean
    }
    newExpandedMap = toggleChildrenOptions(
      children,
      newSelected,
      newExpandedMap
    )
    // toggleParentOptions(clickedOption)
    // if (newSelected) {
    setExpandedMap({ ...newExpandedMap, [option.value]: newSelected })
    // }
    onItemUpdate(updatedCategory)
  }

  const handleExpand = (option: CheckboxFilterOption) => {
    if (option.customAction) {
      option.customAction()
      return
    }

    setExpandedMap({
      ...expandedMap,
      [option.value]: !expandedMap[option.value],
    })
  }

  return (
    <div className={className}>
      <div
        style={{
          maxHeight: maxScrollItems ? maxScrollItems * 36 : undefined,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <CheckboxFilterItemRecursive
          expandedMap={expandedMap}
          onExpand={handleExpand}
          options={options}
          onClick={toggleOption}
          firstLevel={true}
          expanded
        />
        {/* {options.map((option: CheckboxFilterOption) => (
          <div key={option.value} className="my-2">
            <CheckboxFilterItem
              option={option}
              selected={option.selected}
              onClick={() => toggleOption(option)}
            />
            {option.children?.map((secondLevel) => (
              <div key={secondLevel.value} className="ml-4">
                <CheckboxFilterItem
                  option={secondLevel}
                  selected={secondLevel.selected}
                  onClick={() => toggleOption(secondLevel)}
                />
                {secondLevel.children?.map((thirdLevel) => (
                  <div key={thirdLevel.value} className="ml-4">
                    <CheckboxFilterItem
                      option={thirdLevel}
                      selected={thirdLevel.selected}
                      onClick={() => toggleOption(thirdLevel)}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))} */}
      </div>
    </div>
  )
}

export default CheckboxTreeFilter
